import { Ruler } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { SizeChart } from "./SizeChart";

export const CompareSizes = ({ active, testId = "compare-sizes-button" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" className="inline-flex items-center gap-1.5 text-sm font-bold underline decoration-lime-500 decoration-2 underline-offset-4 hover:text-lime-700" data-testid={testId}>
        <Ruler className="h-4 w-4" /> Compare sizes
      </button>
    </DialogTrigger>
    <DialogContent className="max-h-[90vh] max-w-4xl grid-cols-1 overflow-y-auto overflow-x-hidden rounded-none" data-testid="compare-sizes-dialog">
      <DialogHeader><DialogTitle className="font-display text-2xl font-black uppercase">Size chart</DialogTitle></DialogHeader>
      <SizeChart active={active} />
    </DialogContent>
  </Dialog>
);
